import { render, staticRenderFns } from "./ProportionChartsView.vue?vue&type=template&id=3820bca2&scoped=true&"
import script from "./ProportionChartsView.vue?vue&type=script&lang=js&"
export * from "./ProportionChartsView.vue?vue&type=script&lang=js&"
import style0 from "./ProportionChartsView.vue?vue&type=style&index=0&id=3820bca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3820bca2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
